"use strict";

import {
    shopConstants,
    campaignConstants,
    commonConstants,
} from "../_constants";

export const INITIAL_CAMPAIGN_STATE = {
    topPicks: {
        vouchers: [],
        totalVouchers: "",
    },
    favourites: {
        vouchers: [],
        totalVouchers: "",
    },

    trendings: {
        vouchers: [],
        totalVouchers: "",
    },

    voucherDetails: {},
    orderDetails: {},
    voucherWallet: [],
    voucherWalletPollSessionId: undefined,
    browseProducts: { vouchers: [], totalVouchers: 0 },
    popularFilters: [],
    category: [],
    paymentConfirmation: {
        isVisible: false,
        content: {},
        isCompleted: false,
    },
    pointBalance:{},
    rebetSuccess:false,
};

export function shop(state = INITIAL_CAMPAIGN_STATE, action) {
    switch (action.type) {
        case shopConstants.VOUCHER_WALLET_COMPLETE: {
            const payload = action.payload || {};
            const { pollSessionId, ...rest } = payload;
            const walletRows =
                rest.data !== undefined ? rest.data : state.voucherWallet;
            return {
                ...state,
                voucherWallet: [...walletRows],
                voucherWalletPollSessionId: pollSessionId,
            };
        }

        case shopConstants.ORDER_DETAILS_COMPLETE:
            return {
                ...state,
                orderDetails: { ...action.payload.data },
            };

        case shopConstants.TOP_PICKS_COMPLETE:
            return {
                ...state,
                topPicks: { ...action.payload.data },
            };

        case shopConstants.FAVOURITES_COMPLETE:
            return {
                ...state,
                favourites: { ...action.payload.data },
            };

        case shopConstants.TRENDINGS_COMPLETE:
            return {
                ...state,
                trendings: { ...action.payload.data },
            };

        case shopConstants.VOUCHER_DETAILS_COMPLETE:
            return {
                ...state,
                voucherDetails: { ...action.payload.data },
            };

        case campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_COMPLETE:
            return {
                ...state,
                trendings: {
                    ...state.trendings,
                    vouchers: state.trendings.vouchers.map((voucher) => {
                        if (action.payload.id == voucher.id) {
                            voucher.isFavourite = true;
                        }

                        return voucher;
                    }),
                },

                topPicks: {
                    ...state.topPicks,
                    vouchers: state.topPicks.vouchers.map((voucher) => {
                        if (action.payload.id == voucher.id) {
                            voucher.isFavourite = true;
                        }

                        return voucher;
                    }),
                },

                browseProducts: {
                    ...state.browseProducts,
                    vouchers: state.browseProducts.vouchers.map((voucher) => {
                        if (action.payload.id == voucher.id) {
                            voucher.isFavourite = true;
                        }

                        return voucher;
                    }),
                },
            };

        case campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_COMPLETE:
            return {
                ...state,
                trendings: {
                    ...state.trendings,
                    vouchers: state.trendings.vouchers.map((voucher) => {
                        if (action.payload.id == voucher.id) {
                            voucher.isFavourite = false;
                        }

                        return voucher;
                    }),
                },

                topPicks: {
                    ...state.topPicks,
                    vouchers: state.topPicks.vouchers.map((voucher) => {
                        if (action.payload.id == voucher.id) {
                            voucher.isFavourite = false;
                        }

                        return voucher;
                    }),
                },

                browseProducts: {
                    ...state.browseProducts,
                    vouchers: state.browseProducts.vouchers.map((voucher) => {
                        if (action.payload.id == voucher.id) {
                            voucher.isFavourite = false;
                        }

                        return voucher;
                    }),
                },
            };

        case shopConstants.SET_VOUCHER_BY_VALUES:
            return {
                ...state,
                voucherDetails: {
                    ...state.voucherDetails,
                    ...action.payload,
                },
            };

        case shopConstants.BROWSE_PRODUCTS_COMPLETE:
            return {
                ...state,
                browseProducts: { ...action.payload.data },
            };

        case shopConstants.BROWSE_PRODUCTS_POPULAR_FILTER_COMPLETE:
            return {
                ...state,
                popularFilters: [...action.payload.data],
            };

        case shopConstants.BROWSE_PRODUCTS_CATEGORY_COMPLETE:
            return {
                ...state,
                category: [...action.payload.data],
            };

        case shopConstants.BUY_POINTS_COMPLETE:
            return {
                ...state,
                paymentConfirmation: {
                    isVisible: false,
                    content: action.payload,
                    isCompleted: true,
                },
            };

        case commonConstants.SHOW_POPUP:
            return {
                ...state,
                paymentConfirmation: {
                    isVisible: true,
                    content: action.payload,
                    isCompleted: false,
                },
            };

        case commonConstants.HIDE_POPUP:
            return {
                ...state,
                paymentConfirmation: {
                    isVisible: false,
                    content: null,
                    isCompleted: false,
                },
            };

        case shopConstants.REDEEM_VOUCHER_COMPLETE:
            const redeemedIndex = state.voucherWallet.findIndex(
                (order) => order.orderId === action.payload,
            );

            
            state.voucherWallet[redeemedIndex].isRedeemed =
                !state.voucherWallet[redeemedIndex].isRedeemed;

            return {
                ...state,
                // voucherWallet: [...state.voucherWallet],
            };

        case shopConstants.RATE_VOUCHER_COMPLETE:
            const ratingIndex = state.voucherWallet.findIndex(
                (order) => order.orderId === action.payload.orderId,
            );
            state.voucherWallet[ratingIndex].rating = action.payload.rating;
            return {
                ...state,
                voucherWallet: [...state.voucherWallet],
            };
        case shopConstants.SHOP_TLC_GET_POINT_BALANCE_COMPLETE:    
        return {
            ...state,
            pointBalance:action.payload.data
        }
        case shopConstants.SHOP_TLC_REBAT_POINTS_COMPLETE:
            return {
                ...state,
                rebetSuccess:true
            }
        case shopConstants.SHOP_TLC_CLEAR_POINTS:
            return {
                ...state,
                rebetSuccess:false
            }
    }

    return state;
}
